module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page', [_c('template', {
    slot: "title"
  }, [_vm._v("Контакты")]), _vm._v(" "), _c('template', {
    slot: "section"
  }, [_c('div', {
    staticClass: "contacts"
  }, [_c('p', [_c('b', [_vm._v("Адрес в Москве:")]), _c('br'), _vm._v("г. Москва, ул. Садовая-Кудринская д. 11, стр. 1")]), _vm._v(" "), _c('line-break', {
    attrs: {
      "size": "s"
    }
  }), _vm._v(" "), _c('p', [_c('b', [_vm._v("Телефон:")]), _c('br'), _c('a', {
    attrs: {
      "href": "tel:84957739215"
    }
  }, [_vm._v("8 (495) 773-92-15")])]), _vm._v(" "), _c('line-break', {
    attrs: {
      "size": "s"
    }
  }), _vm._v(" "), _c('p', [_c('b', [_vm._v("Электронная почта:")]), _c('br'), _c('a', {
    attrs: {
      "href": "mailto:info@arkenergosbyt.ru"
    }
  }, [_vm._v("info@arkenergosbyt.ru")])]), _vm._v(" "), _c('line-break', {
    attrs: {
      "size": "s"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "map",
    attrs: {
      "id": "arkMap"
    }
  }, [_c('iframe', {
    attrs: {
      "src": "https://yandex.ru/map-widget/v1/?um=constructor%3A4880b45ccb329ad69e4062b81a47419741de1ffa0ce4df019364ed6cf5a66c53&source=constructor",
      "width": "100%",
      "height": "366",
      "frameborder": "0"
    }
  })])], 1)]), _vm._v(" "), _c('template', {
    slot: "aside"
  }, [_c('aside-image', {
    attrs: {
      "image": _vm.imageBg
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60b53920"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Contacts.vue
// module id = 130
// module chunks = 0